import { createAction } from 'redux-actions';
import createGetFileFromS3Epic from '../epics/getFileFromS3Util';

export const GET_FILE_FROM_S3_ACTION_NAME = 'GET_FILE_FROM_S3_ACTION';
export const getFileFromS3Action = createAction(GET_FILE_FROM_S3_ACTION_NAME);

export const getFileFromS3Epic = createGetFileFromS3Epic({
  actionType: GET_FILE_FROM_S3_ACTION_NAME,
});
